import { render } from "./GaleryPage.vue?vue&type=template&id=732d921e&scoped=true"
import script from "./GaleryPage.vue?vue&type=script&lang=js"
export * from "./GaleryPage.vue?vue&type=script&lang=js"

import "./GaleryPage.vue?vue&type=style&index=0&id=732d921e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732d921e"]])

export default __exports__